// API Yapılandırması - Merkezi API Base URL yönetimi
// Bu dosya tüm API URL'lerinin tek bir yerden yönetilmesini sağlar

// REACT_APP_API_URL: build sırasında tam API kökü (örn. https://app.sultanlarbesicilik.com)
// Tanımlı değilse: sultanlarbesicilik.com ana sitedeyken API app.* alt alanına; app.* üzerindeyken aynı host.
// Geliştirmede boş string kullanmayın.
function getApiBaseUrl() {
  const fromEnv = process.env.REACT_APP_API_URL;
  if (fromEnv != null && String(fromEnv).trim() !== '') {
    return String(fromEnv).replace(/\/$/, '');
  }
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const isSultanlar =
      host === 'sultanlarbesicilik.com' ||
      host === 'www.sultanlarbesicilik.com' ||
      (host.endsWith('.sultanlarbesicilik.com') && host.length > 0);
    if (isSultanlar) {
      if (host === 'app.sultanlarbesicilik.com') {
        return `${window.location.protocol}//${window.location.host}`.replace(/\/$/, '');
      }
      // Ana site (www dahil) statik hosting'te kalır; API ayrı alt alan adında Node olarak çalışır.
      return 'https://app.sultanlarbesicilik.com';
    }
  }
  return 'http://localhost:5001';
}

const API_BASE_URL = getApiBaseUrl();

// API endpoint'leri
export const API_ENDPOINTS = {
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/api/users/login`,
  
  // Users endpoints
  USERS: `${API_BASE_URL}/api/users`,
  USER_BY_ID: (id) => `${API_BASE_URL}/api/users/${id}`,
  CHECK_PASSWORD: `${API_BASE_URL}/api/users/check-password`,
  CHANGE_PASSWORD: (id) => `${API_BASE_URL}/api/users/${id}/change-password`,
  
  // Animals endpoints
  ANIMALS: `${API_BASE_URL}/api/animals`,
  ANIMAL_BY_ID: (id) => `${API_BASE_URL}/api/animals/${id}`,
  ANIMAL_WEIGHTS: (id) => `${API_BASE_URL}/api/animals/${id}/weights`,
  ANIMAL_SALE: (id) => `${API_BASE_URL}/api/animals/${id}/sale`,
  ANIMAL_SALES: (id) => `${API_BASE_URL}/api/animals/${id}/sales`,
  ANIMAL_SHARE_SALES: (id) => `${API_BASE_URL}/api/animals/${id}/share-sales`,
  ANIMAL_SHARE_SALE: (id) => `${API_BASE_URL}/api/animals/${id}/share-sale`,
  SHARE_SALES_ALL: `${API_BASE_URL}/api/animals/share-sales/all`,
  ANIMALS_COUNT_SMALL: `${API_BASE_URL}/api/animals/count/small`,
  ANIMALS_COUNT_LARGE: `${API_BASE_URL}/api/animals/count/large`,
  ANIMALS_COUNT: `${API_BASE_URL}/api/animals/count`,
  TOP_BRANCH: `${API_BASE_URL}/api/animals/top-branch`,
  TOP_SALESPERSON: `${API_BASE_URL}/api/animals/top-salesperson`,
  
  // Tahsilat endpoints
  TAHSILATLAR: (params) => `${API_BASE_URL}/api/tahsilatlar${params ? '?' + params : ''}`,
  TAHSILAT_KAYDET: `${API_BASE_URL}/api/tahsilat-kaydet`,
  
  // Reports endpoints
  REPORTS_USERS: (params) => `${API_BASE_URL}/api/reports/users${params ? '?' + params : ''}`,
  REPORTS_BRANCHES: `${API_BASE_URL}/api/reports/branches`,
  REPORTS_PERSONEL: (params) => `${API_BASE_URL}/api/reports/personel${params ? '?' + params : ''}`,
  REPORTS_KURUM: (params) => `${API_BASE_URL}/api/reports/kurum${params ? '?' + params : ''}`,
  REPORTS_KASA: (params) => `${API_BASE_URL}/api/reports/kasa${params ? '?' + params : ''}`,
  
  // Expenses endpoints
  EXPENSES_BRANCHES: `${API_BASE_URL}/api/expenses/branches`,
  EXPENSES_ADD: `${API_BASE_URL}/api/expenses/add`,
  
  // Kesim endpoints
  KESIM_ANIMAL: (id) => `${API_BASE_URL}/api/kesim/animal/${id}`,
  KESIM_SAVE: `${API_BASE_URL}/api/kesim/save`,
  
  // Sistem / veritabanı (yalnızca admin)
  SYSTEM_BACKUP: `${API_BASE_URL}/api/system/backup`,
  SYSTEM_RESET: `${API_BASE_URL}/api/system/reset`,
  SYSTEM_RESTORE: `${API_BASE_URL}/api/system/restore`,

  // WhatsApp endpoints
  WHATSAPP_SEND: `${API_BASE_URL}/api/whatsapp/send`,

  // Content planner endpoints
  CONTENT_PLANNER_ITEMS: `${API_BASE_URL}/api/content-planner/items`,
  CONTENT_PLANNER_ITEM_BY_ID: (id) => `${API_BASE_URL}/api/content-planner/items/${id}`,
  CONTENT_PLANNER_REORDER: `${API_BASE_URL}/api/content-planner/items/reorder`,
  
  // Uploads - görsel URL'leri için
  UPLOADS: (path) => `${API_BASE_URL}${path.startsWith('/') ? path : '/' + path}`,
};

// API helper fonksiyonları
export const apiRequest = async (url, options = {}) => {
  const defaultOptions = {
    headers: {
      'Content-Type': 'application/json',
    },
  };

  const config = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers,
    },
  };

  try {
    const response = await fetch(url, config);
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        error: `HTTP ${response.status}: ${response.statusText}`,
      }));
      throw new Error(errorData.error || errorData.message || 'API hatası oluştu');
    }
    
    return await response.json();
  } catch (error) {
    console.error('API Request Error:', error);
    throw error;
  }
};

// GET isteği helper'ı
export const apiGet = (url, params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const fullUrl = queryString ? `${url}?${queryString}` : url;
  return apiRequest(fullUrl);
};

// POST isteği helper'ı
export const apiPost = (url, data = {}) => {
  return apiRequest(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

// PUT isteği helper'ı
export const apiPut = (url, data = {}) => {
  return apiRequest(url, {
    method: 'PUT',
    body: JSON.stringify(data),
  });
};

// DELETE isteği helper'ı
export const apiDelete = (url) => {
  return apiRequest(url, {
    method: 'DELETE',
  });
};

export default API_BASE_URL;

